var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Lookups = EY.Consultation.Lookups;
var Configuration = Lookups.Configuration = Lookups.Configuration || {};
var Resources = EY.Consultation.Resources = EY.Consultation.Resources || {};

function apis() {
    Lookups.RedBoxCountryApi = _.reduce(Resources.RedboxApis, function (memo, item) {
        memo[item.id] = item.api === '-DEFAULT-' ? Lookups.API.Consultation : item.api;
        return memo;
    }, {});
    Lookups.RedBoxCountryZoneApi = _.invert(_.reduce(Resources.RedboxApis, function (memo, item) {
        memo[item.zoneKey] = item.api === '-DEFAULT-' ? Lookups.API.Consultation : item.api;
        return memo;
    }, {}));
    Lookups.RedBoxCountryZone = _.reduce(Resources.RedboxApis, function (memo, item) {
        memo[item.id] = item.zoneKey;
        return memo;
    }, {});
    Lookups.RedBoxLocation = _.reduce(Resources.RedboxApis, function (memo, item) {
        memo[item.id] = item.location;
        return memo;
    }, {});
}

function configuration() {
    _.extend(Configuration, {
        DaysForApproval: 60,
        DocumentSize: 10 * 1024 * 1024,
        MaxDocumentSize: 30 * 1024 * 1024,
        OpenRecordInNewTab: false
    });
}

function enumerations() {
    _.chain(Resources.Enumeration).groupBy('type').each(function (enumeration, key) {
        Lookups[key] = _.reduce(enumeration, function (memo, item) {
            memo[_.last(item.id.split('_'))] = item.id;
            return memo;
        }, {});
    }).value();
}

function geographies() {
    var geography = {};
    var geographyFiltered = {};
    var geographiesToHide = Configuration.GeographiesToHide && new RegExp(Configuration.GeographiesToHide);

    Resources.Geography = !!geographiesToHide ?
        _.filter(Resources.Geography, function (g) {
             return !g.id.match(geographiesToHide);
        }) : Resources.Geography;

    Resources.GeographyFiltered = _.reject(Resources.Geography, { active: false });
    geography = _.groupBy(Resources.Geography, 'type');
    geographyFiltered = _.groupBy(Resources.GeographyFiltered, 'type');
    geography = _.groupBy(Resources.Geography, 'type');
    _.extend(Resources, {
        Areas: geography.Area,
        Countries: geography.Country,
        Offices: geography.Office,
        Regions: geography.Region,
        SubCountries: geography.SubCountry,
        AreasFiltered: geographyFiltered.Area,
        CountriesFiltered: geographyFiltered.Country,
        OfficesFiltered: geographyFiltered.Office,
        RegionsFiltered: geographyFiltered.Region,
        SubCountriesFiltered: geographyFiltered.SubCountry
    });
}

function configure() {
    configuration();
    enumerations();
    geographies();
    apis();
}

function fetch(type, name, url) {
    return _.extend(new Backbone.Collection(), { url: url || (Lookups.API.Consultation + type) }).fetch().then(function (response) {
        Resources[name || type] = response;
    });
}

module.exports.configure = function () {
    return $.when(fetch('ApproverGroup'),
        fetch('Enumeration'),
        fetch('Geography', 'Geography', Lookups.API.Geography + 'Geography'),
        fetch('Industry'),
        fetch('Question', 'Questions'),
        fetch('RedboxApi', 'RedboxApis'),
        fetch('Role', 'Roles')
    ).then(configure);
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Lookups.js